import Navbar from "../../components/layout/Navbar/Navbar";
import Footer from "../../components/layout/Footer/Footer";
import "./ContactUs.css";
import FloatingChatButton from "../../components/layout/FloatingChatButton/FloatingChatButton";

const ContactUs = () => {

  return (
    <>
      <Navbar />
      <div className="contact-us-page">
        <section className="contact-hero">

          <div className="contact-hero-content">
            <h1 className="contact-hero-title">Get in Touch</h1>
            <p className="contact-hero-subtitle">
              Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
            </p>
          </div>
        </section> 

        <section className="contact-faq">
          <div className="faq-container">
            <h2 className="faq-title">Frequently Asked Questions</h2>
            <div className="contact-faq-grid">
              <div className="contact-faq-item">
                <h4>How quickly will I get a response?</h4>
                <p>We aim to respond to all inquiries within 24 hours during business days.</p>
              </div>
              <div className="contact-faq-item">
                <h4>What are your support hours?</h4>
                <p>Monday to Friday, 9:00 AM - 6:00 PM WAT. For urgent matters, call us anytime.</p>
              </div>
              <div className="contact-faq-item">
                <h4>Can I track my order?</h4>
                <p>Yes! Use the tracking feature in the Squaay app to monitor your delivery in real-time.</p>
              </div>
              <div className="contact-faq-item">
                <h4>How do I report an issue?</h4>
                <p>Contact us via email or phone with your order number and details of the issue.</p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <FloatingChatButton />
      <Footer />
    </>
  );
};

export default ContactUs;
